export { default } from './ContentHeader'
